import { render } from "./AccessibilityInput.vue?vue&type=template&id=6a62f27c"
import script from "./AccessibilityInput.vue?vue&type=script&lang=js"
export * from "./AccessibilityInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__